export const WHITE_CHECKER = '0';
export const BLACK_CHECKER = 'x';
export const KING = 'M';
export const EMPTY_CELL = '.';
export const SEPARATOR = '_';
